// 加载和上传的盒子的显示隐藏
export const domShowFu = (ele: string, val: boolean) => {
  const dom: HTMLDivElement = document.querySelector(ele)!
  if (dom) {
    if (val) {
      dom.style.opacity = '1'
      dom.style.pointerEvents = 'auto'
    } else {
      dom.style.opacity = '0'
      dom.style.pointerEvents = 'none'
    }
  }
}
